import Prescription from "@/components/prescription.vue";
import {Delete, DeleteFilled} from "@element-plus/icons-vue";
import {
    getPrescriptionDetail,
    listMedicine,
    listMedicineDecoction
} from "@/api";
import {message} from "@/assets/utils/common";

export default {
    components: {DeleteFilled, Delete, Prescription},
    props: {
        pagename: ""
    },
    data() {
        return {
            headImg: "",
            sysName: "",
            prescriptionDialogVisible: false,
            direction: 'rtl',
            changeMedCountDialogVisible: false, // 按倍改剂量
            loading: false,

            medicineList: [],
            medicineTotle: 0,
            medicineHeavy: 0,
            medRange: [],
            chooseMedicineId: null,
            sameMedicineList: [],
            doMedicineList: [],
            docMedicineArray: [],
            prescriptionInfo: {
                preName: null,
                instructions: null,
                docPrescriptionMedicineList: null,
                takeWay: null,
                takeNum: null,
                dayTakeNum: null,
                takeTimes: null,
                docAdvice: null,
            },
            medicineInfo: {
                changeGcount: false,
                changeMed: false,
                focusGcount: false,
                focusMeName: false,
                medicineId: null,
                meName: null,
                price: null,
                gCount: "",
                newGCount: "",
                meRemark: null,
                mCount: null,
                decoctionId: null,
                decoctionName: null,
            },
            preId: null,
            pretype: null,
            editBoolean: false,
            indexeat: 0,
            eatWayArray: ["内服", "外用"],
            queryParams: {
                meName: null
            },
            medList: [],
            cursorspacing: 78,
            inputHeight: 0,
            scrollViewHeight: 218,
            toScrollViewId: "med_0",
            billingType: '0', // 开单类型(0=颗粒,1=饮片,2=膏方,3=水丸)
            billingTypeName: "颗粒",
            multipleValue: 1, // 修改倍数
            multipleHeavy: 0,
            decoctionList: [],
            addDecoctionMedicineId: null, // 要添加煎法的药材ID
            choosePreId: null, // 所选常用处方ID
            preMedWay: 'replace', // 选择常用处方时，药材的添加方式（替换或追加）
            medCountPrice: 0, //药材费用
            newRuleOpen: false,
        }
    },
    created() {
        // console.log(window.sessionStorage.getItem("user"));
        let user = JSON.parse(window.sessionStorage.getItem("user"));
        this.headImg = user.avatar;
        this.sysName = user.nickName;
        // console.log(this.sysName);
        console.log("this.pagename");
        console.log(this.pagename);
    },
    mounted() {
        this.prescriptionInfo.takeWay = "0";
        let newRuleOpen = window.sessionStorage.getItem('newRuleOpen');
        console.log("newRuleOpen >>>>> " + newRuleOpen);
        if (newRuleOpen === 'true' || newRuleOpen) {
            this.newRuleOpen = true;
        } else {
            this.newRuleOpen = false;
        }

        this.medicineList = JSON.parse(window.sessionStorage.getItem('medicineList'));
        this.choosePreId = window.sessionStorage.getItem('choosePreId');
        this.billingType = window.sessionStorage.getItem('billingType');
        this.preMedWay = window.sessionStorage.getItem('addType'); // 选择常用处方时，药材的添加方式（替换或追加）
        console.log("billingType >>>>> " + this.billingType);
        if (this.billingType !== null && this.billingType !== "") {
            if (this.billingType === '0') {
                this.billingTypeName = '颗粒';
            } else if (this.billingType === '1') {
                this.billingTypeName = '饮片';
            } else if (this.billingType === '2') {
                this.billingTypeName = '膏方';
            } else if (this.billingType === '3') {
                this.billingTypeName = '水丸';
            }
        } else {
            this.billingType = '0';
            this.billingTypeName = '颗粒';
        }
        if (this.choosePreId !== null && this.choosePreId !== "") {
            this.getPrescriptionInfo();
        } else {
            this.getMedicineList();
        }
        if (this.billingType !== '0') {
            this.qryMedicineDecoctionList();// 查询药材煎法信息
        }
    },
    updated() {
        let newRuleOpen = window.sessionStorage.getItem('newRuleOpen');
        console.log("newRuleOpen >>>>> " + newRuleOpen);
        if (newRuleOpen === 'true') {
            this.newRuleOpen = true;
        } else {
            this.newRuleOpen = false;
        }
    },
    methods: {

        // 查询药材煎法信息
        qryMedicineDecoctionList() {
            console.log("查询药材煎法信息");
            this.decoctionList = [];
            let dictType = "medicine_decoct_way";
            listMedicineDecoction(dictType).then(response => {
                console.log(response);
                if (response.data.code === 200) {
                    let decoctionDictList = response.data.data;
                    decoctionDictList.forEach(item => {
                        this.decoctionList.push({
                            decoctionId: item.dictValue,
                            decoctionName: item.dictLabel,
                        });
                    })
                }
            });
            console.log(JSON.stringify(this.decoctionList))
        },


        // 选择处方模版弹窗关闭
        getPreDrawerStatus() {
            console.log("billingType >>>>> " + this.billingType);
            this.prescriptionDialogVisible = false;
            this.choosePreId = window.sessionStorage.getItem('choosePreId');
            this.preMedWay = window.sessionStorage.getItem('addType'); // 选择常用处方时，药材的添加方式（替换或追加）
            console.log("getPreDrawerStatus choosePreId >>>>> " + this.choosePreId);
            if (this.choosePreId !== null && this.choosePreId !== "") {
                this.getPrescriptionInfo();
                window.sessionStorage.removeItem('choosePreId');
            }
            this.billingType = window.sessionStorage.getItem('billingType');
            if (this.billingType !== "" && this.billingType !== null && this.billingType !== undefined) {
                if (this.billingType === '0') {
                    this.billingTypeName = '颗粒';
                } else if (this.billingType === '1') {
                    this.billingTypeName = '饮片';
                } else if (this.billingType === '2') {
                    this.billingTypeName = '膏方';
                } else if (this.billingType === '3') {
                    this.billingTypeName = '水丸';
                }
            } else {
                this.billingType = '0';
                this.billingTypeName = '颗粒';
                window.sessionStorage.setItem("billingType", "0");
            }
        },


        getPrescriptionInfo() {
            console.log("getPrescriptionInfo choosePreId >>>>> " + this.choosePreId);
            getPrescriptionDetail(this.choosePreId).then(response => {
                // console.log(response);
                this.prescriptionInfo = response.data.data;
                if (this.medicineList !== null && this.medicineList !== "" && this.medicineList.length > 0) {
                    this.docMedicineArray = [];
                    this.medicineList.forEach(melist => {
                        if (melist.meName !== null && melist.meName !== "" && melist.meName !== undefined) {
                            melist.meName = melist.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                            if (this.billingType === "0") {
                                if (melist.newGCount === null) {
                                    melist.newGCount = melist.gCount;
                                }
                                if (melist.newRatio === null) {
                                    melist.newRatio = 1;
                                }
                                if (this.newRuleOpen) {
                                    melist.gCount = parseFloat(parseFloat(melist.newGCount) * parseFloat(melist.newRatio)).toFixed(2);
                                } else {
                                    melist.gCount = melist.newGCount;
                                }
                            } else {
                                melist.newGCount = melist.gCount;
                            }
                            let mCount = parseFloat(parseFloat(melist.gCount) * parseFloat(melist.price)).toFixed(2);
                            if (melist.meStatus === null ||  melist.meStatus === "" || melist.meStatus === undefined) {
                                melist.meStatus = "0";
                            }
                            this.docMedicineArray.push({
                                medicineId: melist.medicineId,
                                meName: melist.meName,
                                price: melist.price,
                                gCount: melist.gCount,
                                newGCount: melist.newGCount,
                                newRatio: melist.newRatio,
                                standard: melist.standard,
                                meRemark: melist.meRemark,
                                mCount: mCount,
                                decoctionId: melist.decoctionId,
                                decoctionName: melist.decoctionName,
                                drugProperty: melist.drugProperty,
                                meStatus: melist.meStatus
                            });
                        }
                    })
                }
                this.doMedicineList = this.prescriptionInfo.docPrescriptionMedicineList;
                // console.log(this.prescriptionInfo);
                if (this.preMedWay !== null && this.preMedWay !== "" && this.preMedWay !== undefined) {
                    if (this.preMedWay === 'replace') {
                        this.docMedicineArray = [];
                        this.docMedicineArrayPush(); // 将处方模版的药品拼接到药品列表中
                    } else if (this.preMedWay === 'add') {
                        this.sameMedicineList = [];
                        if (this.doMedicineList !== null && this.doMedicineList.length > 0) {
                            this.doMedicineList.forEach((melist) => {
                                this.docMedicineArray.forEach((doMelist) => {
                                    if (doMelist.medicineId === melist.medicineId) {
                                        this.sameMedicineList.push(melist);
                                    }
                                })
                            })
                        }
                        console.log(this.sameMedicineList);
                        console.log(this.doMedicineList);
                        if (this.sameMedicineList.length > 0) {
                            this.$confirm("追加的药材中有" + this.sameMedicineList.length + "个药材已存在，将移除重复的药材后继续追加，是否继续？", '温馨提示', {
                                confirmButtonText: '继续',
                                cancelButtonText: '取消',
                                type: 'warning',
                            }).then(() => {
                                if (this.doMedicineList !== null && this.doMedicineList.length > 0) {
                                    this.doMedicineList.forEach((melist) => {
                                        this.sameMedicineList.forEach((sMelist) => {
                                            if (sMelist.medicineId === melist.medicineId) {
                                                this.doMedicineList = this.doMedicineList.filter(melist);
                                            }
                                        })
                                    })
                                }

                                this.docMedicineArrayPush(); // 将处方模版的药品拼接到药品列表中
                            }).catch(() => {
                                this.doMedicineList = this.prescriptionInfo.docPrescriptionMedicineList;
                                console.log('用户取消追加');
                            })
                        } else {
                            this.docMedicineArrayPush(); // 将处方模版的药品拼接到药品列表中
                        }
                    }
                }

                this.clearNotUseInputLine();// 清除未选择药材的输入项
                window.sessionStorage.removeItem('medicineList');
                window.sessionStorage.setItem('medicineList', JSON.stringify(this.docMedicineArray));
                this.toAddMedical();

                this.prescriptionInfo.docPrescriptionMedicineList = [];
                this.prescriptionInfo.docPrescriptionMedicineList = this.docMedicineArray;

                this.medicineTotle = this.docMedicineArray.length;
                this.medicineHeavy = this.getMedicineHeavyFn();
                this.multipleHeavy = parseFloat(parseFloat(this.multipleValue) * parseFloat(this.medicineHeavy)).toFixed(2);
                this.medCountPrice = this.getMedCountPrice();
            });
        },


        // 将处方模版的药品拼接到药品列表中
        docMedicineArrayPush() {
            console.log(this.doMedicineList);
            if (this.doMedicineList !== null && this.doMedicineList.length > 0) {
                let errorNum = 0;
                this.doMedicineList.forEach((melist) => {
                    if (melist.meName !== null && melist.meName !== "" && melist.meName !== undefined) {
                        melist.meName = melist.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                        if (this.billingType === "0") {
                            if (melist.newGCount === null) {
                                melist.newGCount = melist.gCount;
                            }
                            if (melist.newRatio === null) {
                                melist.newRatio = 1;
                            }
                            if (this.newRuleOpen) {
                                melist.gCount = parseFloat(parseFloat(melist.newGCount) * parseFloat(melist.newRatio)).toFixed(2);
                            } else {
                                melist.gCount = melist.newGCount;
                            }
                        } else {
                            melist.newGCount = melist.gCount;
                        }

                        let mCount;
                        if (melist.gCount === "" || melist.gCount === null || melist.gCount === undefined) {
                            mCount = parseFloat(parseFloat(0) * parseFloat(melist.price)).toFixed(2);
                        } else {
                            mCount = parseFloat(parseFloat(melist.gCount) * parseFloat(melist.price)).toFixed(2);
                        }
                        if (melist.meStatus === null ||  melist.meStatus === "" || melist.meStatus === undefined) {
                            melist.meStatus = "0";
                        }
                        this.docMedicineArray.push({
                            changeGcount: false,
                            changeMed: false,
                            focusMeName: false,
                            focusGcount: false,
                            medicineId: melist.medicineId,
                            meName: melist.meName,
                            price: melist.price,
                            gCount: melist.gCount,
                            newGCount: melist.newGCount,
                            newRatio: melist.newRatio,
                            standard: melist.standard,
                            meRemark: melist.meRemark,
                            mCount: mCount,
                            decoctionId: melist.decoctionId,
                            decoctionName: melist.decoctionName,
                            decoctWay: melist.decoctWay,
                            meStatus: melist.meStatus
                        });
                    } else {
                        errorNum++;
                    }
                })
                if (errorNum > 0) {
                    message("存在未知药材信息，请重新选择处方模版", "error");
                }
            }
        },


        // 新增药材
        toAddMedical() {
            let hasEmptySelect = false;
            this.docMedicineArray.forEach((item) => {
                if (item.medicineId === null) {
                    hasEmptySelect = true;
                }
            })
            if (!hasEmptySelect) {
                this.docMedicineArray.push({
                    changeGcount: false,
                    changeMed: false,
                    focusMeName: false,
                    focusGcount: false,
                    medicineId: null,
                    meName: null,
                    price: parseFloat(0).toFixed(2),
                    gCount: null,
                    newGCount: null,
                    newRatio: null,
                    standard: null,
                    meRemark: null,
                    mCount: parseFloat(0).toFixed(2),
                    decoctionId: null,
                    decoctionName: null,
                    decoctWay: null,
                    meStatus: null
                });
                this.chooseMedicineId = null;
                this.medicineTotle = this.docMedicineArray.length - 1;
                this.medicineHeavy = this.getMedicineHeavyFn();
                this.multipleHeavy = parseFloat(parseFloat(this.multipleValue) * parseFloat(this.medicineHeavy)).toFixed(2);
                this.medCountPrice = this.getMedCountPrice();
            }
        },

        // 得到焦点选中 - 最完善版本
        focusSelect(event) {
            console.log("event >>>>" + event);
            // 确保事件对象存在
            if (!event) return;

            // 获取目标元素
            const element = event.target || event.currentTarget;

            // 检查元素是否存在且支持 select 方法
            if (element && element.select && typeof element.select === 'function') {
                try {
                    element.select();
                } catch (error) {
                    console.warn('无法选中元素:', error);
                }
            } else {
                console.warn('目标元素不支持 select 方法:', element);
            }
        },


        // 获取药品信息
        getMedicineList() {
            this.docMedicineArray = [];
            console.log(JSON.stringify(this.medicineList));
            if (this.medicineList !== null && this.medicineList !== "" && this.medicineList.length > 0) {
                this.medicineList.forEach((melist) => {
                    if (this.billingType === "0") {
                        if (melist.newGCount === null) {
                            melist.newGCount = melist.gCount;
                        }
                        if (this.newRuleOpen) {
                            melist.gCount = parseFloat(parseFloat(melist.newGCount) * parseFloat(melist.newRatio)).toFixed(2);
                        } else {
                            melist.gCount = melist.newGCount;
                        }
                    } else {
                        melist.newGCount = melist.gCount;
                    }
                    let mCount;
                    if (melist.gCount === "" || melist.gCount === null || melist.gCount === undefined) {
                        mCount = parseFloat(parseFloat(0) * parseFloat(melist.price)).toFixed(2);
                    } else {
                        mCount = parseFloat(parseFloat(melist.gCount) * parseFloat(melist.price)).toFixed(2);
                    }
                    if (melist.meStatus === null ||  melist.meStatus === "" || melist.meStatus === undefined) {
                        melist.meStatus = "0";
                    }
                    this.docMedicineArray.push({
                        changeGcount: false,
                        changeMed: false,
                        focusMeName: false,
                        focusGcount: false,
                        medicineId: melist.medicineId,
                        meName: melist.meName,
                        price: melist.price,
                        gCount: melist.gCount,
                        newGCount: melist.newGCount,
                        newRatio: melist.newRatio,
                        standard: melist.standard,
                        meRemark: melist.meRemark,
                        mCount: mCount,
                        decoctionId: melist.decoctionId,
                        decoctionName: melist.decoctionName,
                        decoctWay: melist.decoctWay,
                        meStatus: melist.meStatus
                    });
                })
                this.toAddMedical(); // 默认新增一个药材项
                this.medicineTotle = this.docMedicineArray.length - 1;
            } else {
                this.toAddMedical(); // 默认新增一个药材项
                this.medicineTotle = this.docMedicineArray.length - 1;
            }

            window.sessionStorage.removeItem('medicineList');
            window.sessionStorage.setItem('medicineList', JSON.stringify(this.docMedicineArray));

            this.prescriptionInfo.docPrescriptionMedicineList = [];
            this.prescriptionInfo.docPrescriptionMedicineList = this.docMedicineArray;

            this.medicineHeavy = this.getMedicineHeavyFn();
            this.multipleHeavy = parseFloat(parseFloat(this.multipleValue) * parseFloat(this.medicineHeavy)).toFixed(2);
            this.medCountPrice = this.getMedCountPrice();
        },

        // 获取药品总重
        getMedicineHeavyFn() {
            let allGCount = parseFloat(0);
            this.docMedicineArray.forEach(item => {
                if (item.medicineId !== null && item.medicineId !== "" && item.medicineId !== undefined) {
                    allGCount += parseFloat(item.gCount);
                }
            })
            return parseFloat(allGCount).toFixed(2);
        },

        // 计算药方的药费
        getMedCountPrice() {
            let countPrice = 0;
            if (this.docMedicineArray.length > 0) {
                this.docMedicineArray.forEach(mlist => {
                    mlist.mCount = mlist.mCount === "" || mlist.mCount === null || mlist.mCount === undefined ? 0 : mlist.mCount;
                    countPrice += parseFloat(mlist.mCount);
                });
            }
            return parseFloat(countPrice).toFixed(2);
        },

        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },


        // 查询药品信息
        qryMedicineList(queryMeName) {
            this.loading = true;
            this.queryParams.meName = queryMeName;
            if (this.billingType === "0" || this.billingType === 0) {
                this.queryParams.meType = 0;
            } else {
                this.queryParams.meType = 1;
            }
            listMedicine(this.queryParams).then(response => {
                console.log(response)
                this.medRange = [];
                this.medList = [];
                this.loading = true;
                if (response.data.code === 200) {
                    this.medList = response.data.rows;
                    // this.chooseMedicineId = this.medList[0].medicineId;
                    this.medList.forEach(item => {
                        item.meName = item.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                        this.medRange.push({
                            "value": item.medicineId,
                            "text": item.meName,
                            "price": item.price,
                            "ratioPrice": item.ratioPrice,
                            "newRatio": item.newRatio,
                            "standard": item.standard,
                            "decoctWay": item.decoctWay,
                            "meStatus": item.meStatus
                        });
                    })
                }

            });
        },

        // 确定选择药品
        sureChooseMedicine(index) {
            this.medList.forEach(item => {
                if (this.chooseMedicineId === item.medicineId) {
                    this.chooseThisMed(index, item);
                }
            })
        },

        // 确定选择药品
        chooseThisMed(index, itm) {
            let copyFlag = false;
            let defaultDecoctionId;
            let defaultDecoctionName;
            this.docMedicineArray.forEach((item) => {
                if (item.medicineId === itm.medicineId) {
                    copyFlag = true;
                }
            })
            if (itm.decoctWay !== null && itm.decoctWay !== "" && itm.decoctWay !== undefined) {
                this.decoctionList.forEach((item) => {
                    if (item.decoctionId === itm.decoctWay) {
                        defaultDecoctionId = item.decoctionId;
                        defaultDecoctionName = item.decoctionName;
                    }
                })
            }
            console.log("defaultDecoctionId >>>> " + defaultDecoctionId);
            console.log("defaultDecoctionName >>>> " + defaultDecoctionName);
            if (copyFlag) {
                message(itm.meName + " 药材已存在！", "error");
                this.chooseMedicineId = null;
                this.docMedicineArray.forEach((item, inx) => {
                    if (index === inx) {
                        item.changeGcount = false;
                        item.changeMed = false;
                        item.focusMeName = false;
                        item.focusGcount = false;
                        item.medicineId = null;
                        item.meName = null;
                        item.price = parseFloat(0).toFixed(2);
                        item.gCount = "";
                        item.newGCount = "";
                        item.newRatio = "";
                        item.standard = "";
                        item.meRemark = null;
                        item.mCount = parseFloat(0).toFixed(2);
                        item.decoctionId = null;
                        item.decoctionName = null;
                        item.decoctWay = null;
                        item.meStatus = null;
                    } else {
                        item.changeGcount = false;
                    }
                });
            } else {
                this.$nextTick(() => {
                    event.stopPropagation();
                    this.$refs[`gCount${itm.medicineId}`][0].focus();
                })
                this.docMedicineArray.forEach((item, inx) => {
                    if (inx === index) {
                        item.changeGcount = true;
                        item.changeMed = false;
                        item.focusMeName = false;
                        item.focusGcount = true;
                        item.medicineId = itm.medicineId;
                        item.meName = itm.meName;
                        item.price = itm.price;
                        item.meRemark = itm.meRemark;
                        item.newRatio = itm.newRatio;
                        item.standard = itm.standard;
                        item.meStatus = itm.meStatus;
                        if (this.billingType === "0") {
                            if (item.newGCount === "" || item.newGCount === null || item.newGCount === undefined) {
                                item.newGCount = parseInt(0);
                            }
                            if (this.newRuleOpen) {
                                item.gCount = parseFloat(parseFloat(item.newGCount) * parseFloat(item.newRatio)).toFixed(2);
                            } else {
                                item.gCount = item.newGCount;
                            }
                        } else {
                            item.newGCount = item.gCount;
                        }
                        if (item.gCount === "" || item.gCount === null || item.gCount === undefined) {
                            item.gCount = "0";
                            item.mCount = parseFloat(0).toFixed(2);
                        } else {
                            item.mCount = parseFloat(parseFloat(item.gCount) * parseFloat(item.price)).toFixed(2);
                        }
                        if (itm.decoctWay !== null && itm.decoctWay !== "" && itm.decoctWay !== undefined) {
                            item.decoctionId = defaultDecoctionId;
                            item.decoctionName = defaultDecoctionName;
                        }
                        item.decoctWay = itm.decoctWay;
                    } else {
                        item.changeGcount = false;
                    }
                    if (inx === this.docMedicineArray.length - 1) {
                        if (item.medicineId !== null && item.medicineId !== "" && item.medicineId !== undefined) {
                            this.toAddMedical(); // 默认新增
                        }
                    }
                })
            }

            window.sessionStorage.removeItem('medicineList');
            window.sessionStorage.setItem('medicineList', JSON.stringify(this.docMedicineArray));

        },

        // 保存药材
        sureEditPopup() {
            let empty = true;
            this.clearNotUseInputLine();// 清除未选择药材的输入项
            this.docMedicineArray.forEach((item) => {
                if (item.gCount == null || item.gCount == "" || item.gCount == undefined || parseFloat(item.gCount) == 0) {
                    message(item.meName + " 未增加重量！", "error");
                    empty = false;
                } else if (item.meStatus !== '0') {
                    message(item.meName + " 已下架，请处理后保存！", "error");
                    empty = false;
                }
            })
            if (empty) {
                window.sessionStorage.removeItem('choosePreId');
                window.sessionStorage.removeItem('addType');
                window.sessionStorage.removeItem('medicineList');
                window.sessionStorage.setItem('medicineList', JSON.stringify(this.docMedicineArray));

                this.medicineTotle = this.docMedicineArray.length;
                this.medicineHeavy = this.getMedicineHeavyFn();
                this.multipleHeavy = parseFloat(parseFloat(this.multipleValue) * parseFloat(this.medicineHeavy)).toFixed(2);
                this.medCountPrice = this.getMedCountPrice();
                // uni.navigateBack();
                this.$emit('medicinalDrawerStatus', false);
            }

        },

        // 一键清空
        cleanAllMedicine() {
            this.$confirm('将要清空所有已选处方药品, 是否继续?', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                window.sessionStorage.removeItem("medicineList");
                this.docMedicineArray = [];
                this.prescriptionInfo.docPrescriptionMedicineList = [];
                this.medicineTotle = 0;
                this.medicineHeavy = this.getMedicineHeavyFn();
                this.multipleHeavy = parseFloat(parseFloat(this.multipleValue) * parseFloat(this.medicineHeavy)).toFixed(2);
                this.medCountPrice = this.getMedCountPrice();
                this.toAddMedical(); // 默认新增
            }).catch(() => {
                console.log('用户取消更换');
            })
        },

        // 取消选择药材
        cancelEditPopup() {
            window.sessionStorage.removeItem('medicineList');
            window.sessionStorage.removeItem('addType');
            // uni.navigateBack();
        },

        // 移除药品
        removeMedicine(index) {
            this.docMedicineArray.forEach((item, inx) => {
                if (inx === index) {
                    this.docMedicineArray.splice(inx, 1);
                }
            })
            this.medicineTotle = this.docMedicineArray.length;
            this.medicineHeavy = this.getMedicineHeavyFn();
            this.medCountPrice = this.getMedCountPrice();
            window.sessionStorage.removeItem('medicineList');
            window.sessionStorage.setItem('medicineList', JSON.stringify(this.docMedicineArray));
        },

        // 增加药采重量
        changeValue(inx) {
            this.docMedicineArray.forEach((item, index) => {
                if (index === inx) {
                    if (item.newGCount === "" || item.newGCount === null || item.newGCount === undefined) {
                        item.newGCount = parseInt(0);
                    }
                    if (this.billingType === "0") {
                        if (this.newRuleOpen) {
                            item.gCount = parseFloat(parseFloat(item.newGCount) * parseFloat(item.newRatio)).toFixed(2);
                        } else {
                            item.gCount = item.newGCount;
                        }
                    } else {
                        item.newGCount = item.gCount;
                    }
                    if (parseFloat(item.gCount) === 0 || item.gCount === "" || item.gCount === null || item.gCount === undefined) {
                        item.gCount = parseInt(0);
                        item.mCount = parseFloat(0).toFixed(2);
                    } else {
                        item.gCount = parseFloat(item.gCount).toFixed(2);
                        item.mCount = parseFloat(parseFloat(item.gCount) * parseFloat(item.price)).toFixed(2);
                    }
                }
            })

            this.medicineHeavy = this.getMedicineHeavyFn();
            this.multipleHeavy = parseFloat(parseFloat(this.multipleValue) * parseFloat(this.medicineHeavy)).toFixed(2);
            this.medCountPrice = this.getMedCountPrice();
            window.sessionStorage.removeItem('medicineList');
            window.sessionStorage.setItem('medicineList', JSON.stringify(this.docMedicineArray));
        },

        // 失去焦点
        blurMedGcount(index) {
            this.docMedicineArray.forEach((item, inx) => {
                if (inx === parseInt(index)) {
                    if (item.newGCount === "" || item.newGCount === undefined || item.newGCount === null) {
                        item.changeGcount = true;
                        item.focusGcount = true;
                        message("请输入" + item.meName + "重量！", "error");
                    } else {
                        item.changeGcount = false;
                        item.focusGcount = false;
                    }
                }
            })
        },


        // 点击选择修改药材
        changeMedGcount(index) {
            this.docMedicineArray.forEach((item, inx) => {
                if (inx === parseInt(index)) {
                    if (item.medicineId !== null && item.medicineId !== "" && item.medicineId !== undefined && item.meStatus === '0') {
                        item.changeGcount = true;
                        item.focusGcount = true;
                    } else {
                        item.changeGcount = false;
                        item.focusGcount = false;
                    }
                } else {
                    item.changeGcount = false;
                    item.focusGcount = false;
                }
            })
        },

        // 聚焦到下一次药品选择
        nextChooseMedicine(inx) {
            this.docMedicineArray.forEach((item, index) => {
                if (index === inx) {
                    item.changeGcount = false;
                    if (parseFloat(item.gCount) !== 0) {
                        this.$nextTick(() => {
                            event.stopPropagation();
                            this.$refs.medSelectInput[0].focus();
                        })
                    }
                }
            })
        },


        // 清除未选择药材的输入项
        clearNotUseInputLine() {
            let spliceInx = [];
            this.docMedicineArray.forEach((item, inx) => {
                if (item.medicineId === null || item.medicineId === "" || item.medicineId === undefined ||
                    item.meName === null || item.meName === "" || item.meName === undefined) {
                    spliceInx.push(inx);
                }
            })
            if (spliceInx.length > 0) {
                for (let i = spliceInx.length - 1; i >= 0; i--) {
                    this.docMedicineArray.splice(spliceInx[i], 1)
                }
            }
        },


        // 选择煎法
        chooseJianfa(item) {
            this.decoctionList.forEach((decItem) => {
                if (decItem.decoctionId === item.decoctionId) {
                    item.decoctionName = decItem.decoctionName;
                }
            })
        },


        // 打开按倍改剂量弹窗
        openChangeCountDialog() {
            this.multipleValue = 1;
            let canOpen = false;
            const changeMedicineArray = [];
            if (this.docMedicineArray.length > 0) {
                this.docMedicineArray.forEach((item) => {
                    if (item.medicineId !== null && item.medicineId !== "" && item.medicineId !== undefined &&
                        item.meName !== null && item.meName !== "" && item.meName !== undefined) {
                        changeMedicineArray.push(item);
                    }
                })
            }
            if (changeMedicineArray.length > 0) {
                canOpen = true;
                changeMedicineArray.forEach((citem) => {
                    if (citem.meName === null || citem.meName === "" || citem.meName === undefined) {
                        message("请先选择药材！", "error")
                        canOpen = false;
                    } else if (citem.gCount === null || citem.gCount === "" || citem.gCount === undefined || parseFloat(citem.gCount) === 0) {
                        message(citem.meName + " 未增加重量！", "error")
                        canOpen = false;
                    }
                })
            } else {
                message("请先选择药材！", "error")
            }
            if (canOpen) {
                this.changeMedCountDialogVisible = true;
            }
        },
        // 关闭按倍改剂量弹窗
        closeCenterPopup() {
            this.changeMedCountDialogVisible = false;
        },

        changeMultipleValue() {
            this.multipleHeavy = parseFloat(parseFloat(this.multipleValue) * parseFloat(this.medicineHeavy)).toFixed(2);
        },

        sureEditNum() {
            this.medicineHeavy = this.multipleHeavy;
            this.docMedicineArray.forEach(item => {
                if (item.gCount !== "" && item.gCount !== null && item.gCount !== undefined) {
                    console.log("sureEditNum");
                    console.log(item.gCount);
                    item.newGCount = parseFloat(parseFloat(item.newGCount) * parseFloat(this.multipleValue)).toFixed(2);
                    item.gCount = parseFloat(parseFloat(item.gCount) * parseFloat(this.multipleValue)).toFixed(2);
                    item.mCount = parseFloat(parseFloat(item.gCount) * parseFloat(item.price)).toFixed(2);
                }
            })
            this.changeMedCountDialogVisible = false;
        },


        // 选择处方模板
        openPrescriptionDrew() {
            this.prescriptionDialogVisible = true;
        },
    }
}
